import React from 'react'
import { Users,AlertCircle ,User,Briefcase, KeyRound , Copy, FileText, Scale, Check, School, Monitor, TrendingDown, BookOpen, TrendingUp, ChevronRight, ChevronDown , Calendar, MapPin } from 'lucide-react';
import { obtenerInfoCotizaciones } from '../../../../compartedRoutes/solicitudes/components/FuncionSolicitudes';
import { formatearFechaCorta, formatearPrecio } from '../../../../../utils/utils';
import EditableField from '../../../../../components/EditableFields';
import BooleanField from '../../../../../components/BooleanField';
import { useDetalleSolicitudModel } from '../../../../../modelos/Solicitudes/modeloSolicitud';
import generarPdfCotizacionMejorado from '../Components/generatePdfSolciituds';

const SolicitudesProPlataforma = ({solicitudesFiltradas,semestreSeleccionado,isPdfButtonDisabled,pdfValidationErrors,configuracion,nombreEmpresaReal,cliente}) => {

  const handleSave = async (id,field, value) =>{

        await actualizarSolicitud(id,nombreEmpresaReal,field,value,'field');

  }

  const {
    actualizarSolicitud
  } = useDetalleSolicitudModel();

  return (
    <div className="space-y-6">
            {solicitudesFiltradas.length > 0 ? (
              <>
                {Object.entries(
                  solicitudesFiltradas.reduce((grupos, solicitud) => {
                    const materia = solicitud.proPlataforma?.materia;
                    if (!grupos[materia]) {
                      grupos[materia] = [];
                    }
                    grupos[materia].push(solicitud);
                    return grupos;
                  }, {})
                ).map(([materia, solicitudesGrupo]) => {
                  // Calcular costo promedio por materia
                  const costoTotalMateria = solicitudesGrupo.reduce((total, solicitud) => {
                    const costoEmpresa = solicitud.proPlataforma?.costoEmpresa || 0;
                    return total + costoEmpresa;
                  }, 0);

                  const precioEmpresaMateria = solicitudesGrupo.reduce((total, solicitud) => {
                  const precioEmpresa = solicitud.proPlataforma?.precioEmpresa || 0;
                    return total + precioEmpresa;
                  }, 0);

                  const gananciaEmpresa =  precioEmpresaMateria - costoTotalMateria;
                  const costoPromedioMateria = costoTotalMateria / solicitudesGrupo.length;
                  
                  return (
                    <div key={materia} className="bg-white rounded-xl shadow-lg overflow-hidden">
                      {/* Header de la materia */}
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 border-b border-gray-200">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-3">
                            <BookOpen className="h-6 w-6 text-blue-600" />
                            <h3 className="text-xl font-bold text-gray-800">{materia}</h3>
                          </div>
                          <div className="flex items-center space-x-4">
                            <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                              {solicitudesGrupo.length} solicitud{solicitudesGrupo.length !== 1 ? 'es' : ''}
                            </span>
                            <span className="bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                              Promedio: ${costoPromedioMateria.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Contenido siempre visible */}
                      <div className="p-6">
                        <div className="overflow-x-auto">
                         <table className="w-full table-fixed">
                            <thead>
                              <tr className="bg-gray-50">
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">ID</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">Fase</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-2/12">Promedio tutor</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-2/12">Precios</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-2/12">Fecha UNAD</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-2/12">Estados</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                              {solicitudesGrupo.map((solicitud, index) => {
                                const infoCotizacion = obtenerInfoCotizaciones(solicitud.cotizaciones);
                                const costoTutor = parseFloat(infoCotizacion.promedio || 0);
                                
                                return (
                                  <tr key={solicitud.id || index} className="hover:bg-gray-50">

                                    {/* ID */}
                                    <td className="px-4 py-4 text-sm font-medium text-blue-600">
                                      #{solicitud.id}
                                    </td>

                                    {/* Fase */}
                                    <td className="px-4 py-4 text-sm text-gray-900">
                                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                                        {solicitud.proPlataforma?.fase || 'N/A'}
                                      </span>
                                    </td>

                                    {/* Promedio de precios tutores*/}
                                    <td className="px-6 py-4">
                                      <div className="flex flex-col space-y-2 text-xs">
                                        {/* Resumen de cantidad */}
                                        <div className="flex items-center text-gray-500">
                                          <Users className="w-3.5 h-3.5 mr-2" />
                                          <span>{infoCotizacion.textoResumen}</span>
                                        </div>

                                        {/* Promedio */}
                                        <div className="flex items-center text-gray-700">
                                          <Scale className="w-3.5 h-3.5 mr-2 text-blue-500" />
                                          <span className="font-medium">{infoCotizacion.textoPromedio}</span>
                                        </div>

                                        {/* Mínimo */}
                                        <div className="flex items-center text-gray-700">
                                          <TrendingDown className="w-3.5 h-3.5 mr-2 text-green-500" />
                                          <span className="font-medium">{infoCotizacion.textoMinimo}</span>
                                        </div>

                                        {/* Máximo */}
                                        <div className="flex items-center text-gray-700">
                                          <TrendingUp className="w-3.5 h-3.5 mr-2 text-red-500" />
                                          <span className="font-medium">{infoCotizacion.textoMaximo}</span>
                                        </div>
                                        
                                       {/* NUEVA SECCIÓN PARA MOSTRAR PARTICIPANTES */}
                                        {infoCotizacion.participantes && infoCotizacion.participantes.length > 0 && (
                                          <div className="pt-2 mt-2 border-t border-gray-200">
                                            <h4 className="font-semibold text-gray-500 mb-2">Participantes:</h4>
                                            <div className="flex flex-wrap gap-2">
                                              {infoCotizacion.participantes.map((participante, index) => (
                                                <span 
                                                  key={index} 
                                                  className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-1 rounded-full"
                                                >
                                                  {participante.nombre}:{' '}
                                                  <span className="font-semibold">{formatearPrecio(participante.precio)}</span>
                                                </span>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    {/* Costo tutor y Precio Empresa */}
                                    <td className="px-4 py-4 text-sm text-gray-900 font-semibold">

                                      <EditableField
                                        field="proPlataforma.costoEmpresa"
                                        label="costo tutor"
                                        value={solicitud.proPlataforma?.costoEmpresa}
                                        type="number"
                                        isAdmin={true}
                                        onSave={(field, value) => handleSave(solicitud.id, field, value)}
                                      />
                                      
                                      <EditableField
                                        field="proPlataforma.precioEmpresa"
                                        label="Precio empresa"
                                        value={solicitud.proPlataforma?.precioEmpresa}
                                        type="number"
                                        isAdmin={true}
                                        onSave={(field, value) => handleSave(solicitud.id, field, value)}
                                      />

                                       

                                    </td>

                                    {/* Fecha UNAD */}
                                    <td className="px-4 py-4 text-sm text-gray-900">
                                      <EditableField
                                        field="proPlataforma.fechaRealUnad"
                                        label="Fecha UNAD"
                                        value={solicitud.proPlataforma?.fechaRealUnad}
                                        type="date"
                                        isAdmin={true}
                                        onSave={(field, value) => handleSave(solicitud.id, field, value)}
                                      />
                                    </td>

                                    {/* Acciones */}
                                    <td className="px-4 py-4 text-sm">
                                      {/* Contenedor principal: Flex vertical con espacio entre elementos */}
                                      <div className="flex flex-col space-y-4 items-start">

                                        {/* 1. Estado */}
                                        <div>
                                          <span className="text-xs font-semibold text-gray-500 mb-1 block">Estado</span>
                                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                            solicitud.Estado === 'AGENDADO' ? 'bg-yellow-100 text-yellow-800' :
                                            solicitud.Estado === 'DISPONIBLE' ? 'bg-green-100 text-green-800' :
                                            'bg-gray-100 text-gray-800'
                                          }`}>
                                            {solicitud.Estado}
                                          </span>
                                        </div>

                                        {/* 2. Es colaborativa ? */}
                                        <BooleanField
                                          field="proPlataforma.esColaborativo"
                                          label="Es colaborativa?"
                                          value={solicitud.proPlataforma?.esColaborativo}
                                          isAdmin={true}
                                          displayAs='toggle'
                                          onSave={(field, value) => handleSave(solicitud.id, field, value)}
                                        />

                                        {/* 3. Tiene Foro? */}
                                        <BooleanField
                                          field="proPlataforma.tieneForo"
                                          label="Tiene foro?"
                                          value={solicitud.proPlataforma?.tieneForo}
                                          isAdmin={true}
                                          displayAs='toggle'
                                          onSave={(field, value) => handleSave(solicitud.id, field, value)}
                                        />

                                        {/* 4. Acción "No Plataforma" */}
                                        <div>
                                          <span className="text-xs font-semibold text-gray-500 mb-1 block">No Plataforma</span>
                                          <button
                                            onClick={() => {
                                              handleSave(solicitud.id, 'proPlataforma.noPlataforma', false);
                                            }}
                                            className="text-red-600 hover:text-red-900 hover:bg-red-50 p-2 rounded-full transition-colors"
                                            title="Marcar como 'No Plataforma'">
                                            ❌
                                          </button>
                                        </div>

                                      </div>
                                    </td>

                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        
                        {/* Subtotal por materia */}
                        <div className="mt-4 bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                          <div className="flex justify-between items-center">
                            <h4 className="font-semibold text-blue-800">Subtotal {materia}:</h4>
                            <div className="flex space-x-6">
                              <span className="text-blue-800 font-bold">
                                Costo Tutores: ${costoTotalMateria.toLocaleString('es-CO')}
                              </span>

                              <span className="text-blue-800 font-bold">
                                Precio Empresa: ${precioEmpresaMateria.toLocaleString('es-CO')}
                              </span>

                              <span className="text-blue-800 font-bold">
                                Ganancia Empresa: ${gananciaEmpresa.toLocaleString('es-CO')}
                              </span>

                            </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                
                {/* Totales generales */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl shadow-lg p-6 border-l-4 border-green-500">
                  <h3 className="text-2xl font-bold text-green-800 mb-4">Totales del Semestre {semestreSeleccionado}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-green-600">
                        {solicitudesFiltradas.length}
                      </div>
                      <div className="text-sm text-green-800">Total Solicitudes</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-green-600">
                        ${solicitudesFiltradas.reduce((total, solicitud) => {
                          const costoEmpresa = solicitud.proPlataforma?.costoEmpresa || 0;
                          return total + costoEmpresa;
                        }, 0).toLocaleString('es-CO')}
                      </div>
                      <div className="text-sm text-green-800">Total Costo Tutores</div>
                    </div>
                    <div className="text-center">
                    <div className="text-3xl font-bold text-green-600">
                      ${solicitudesFiltradas.reduce((total, solicitud) => {
                        const precioEmpresa = solicitud.proPlataforma?.precioEmpresa || 0;
                        return total + precioEmpresa;
                      }, 0).toLocaleString('es-CO')}
                    </div>
                    <div className="text-sm text-green-800">Total Precio Empresa</div>
                  </div>
                  </div>
                  {/* Botón para generar PDF */}
                  <div className="mt-6 text-center">
                    <button
                      onClick={() => generarPdfCotizacionMejorado(cliente, solicitudesFiltradas, semestreSeleccionado, configuracion)}
                      disabled={isPdfButtonDisabled}
                      className={`inline-flex items-center px-6 py-3 font-semibold rounded-lg shadow-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                        isPdfButtonDisabled
                          ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                          : 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500'
                      }`}                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      GENERAR PDF DE COTIZACIÓN
                    </button>
                  </div>

                  {isPdfButtonDisabled && (
                      <div className="mt-4 p-4 bg-red-100 border-l-4 border-red-500 text-red-800 rounded-lg max-w-2xl mx-auto">
                        <div className="flex">
                          <div className="py-1"><AlertCircle className="h-5 w-5 text-red-500 mr-3" /></div>
                          <div>
                            <p className="font-bold text-left">No se puede generar el PDF</p>
                            <ul className="mt-2 list-disc list-inside text-sm text-left">
                              {pdfValidationErrors.map((error, index) => (
                                <li key={index}>{error}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                </div>
              </>
            ) : (
              <div className="text-center py-12 bg-white rounded-xl shadow-lg">
                <FileText className="mx-auto h-12 w-12 text-gray-400 mb-4" />
                <p className="text-gray-500 text-lg">No hay solicitudes para el semestre {semestreSeleccionado}</p>
              </div>
            )}
    </div>
  )

}

export default SolicitudesProPlataforma
